<template>
	<section class="streamer-quotes">
		<div class="container">
			<div class="row">
				<div class="col-md-6">
					<div class="streamer-quotes-description">
						<h2 class="streamer-quotes-description-heading text-uppercase">
							{{ streamingDescription.title | stripTags }}
						</h2>
						<div v-html="streamingDescription.body" class="streamer-quotes-description-text" />
					</div>
				</div>
				<div class="col-md-6">
					<div class="streamer-quotes-content">
						<div v-for="quote in streamersQuotes" :key="quote.id" class="streamer-quotes-content-single">
							<div class="streamer-quotes-content-streamer-image">
								<img :src="quote.logo_url" :alt="quote.title">
							</div>
							<blockquote class="streamer-quotes-content-quote">
								<h5 class="streamer-quotes-content-streamer-name">
									{{ quote.title | stripTags }}:
								</h5>
								<div v-html="quote.body" />
							</blockquote>
						</div>
					</div>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
import { mapState } from "vuex";

export default {
	name: "StreamerQuotes",
	computed: {
		...mapState({
			landingSections: state => state.StarterPc.pageData.landing_page_sections
		}),
		streamingDescription() {
			if (!this.landingSections.length) {
				return {};
			}

			return {
				...this.landingSections[9]
			};
		},
		streamersQuotes() {
			if (!this.landingSections.length) {
				return [];
			}

			return [
				{
					...this.landingSections[10]
				},
				{
					...this.landingSections[11]
				}
			];
		}
	}
};
</script>

<style lang="scss" scoped>
@import "~@s/_asset-mixers.scss";
.streamer-quotes {
    background-image: url("/images/streaming-pc/streamer-quotes-bg.jpg");
    background-size: cover;
    padding: 110px 0;

    @media (min-width: 580px) and (max-width: 991px) {
        padding: 55px 0 70px;
    }

    @media screen and (min-width: 991px) {
        .row {
            display: flex;
            align-items: center;
        }
    }

    @media screen and (max-width: 580px) {
        padding: 30px 0;
    }

    &-description {
        max-width: 500px;

        @media (min-width: 580px) and (max-width: 991px) {
            max-width: initial;
            margin-bottom: 25px;
        }

        @media (min-width: 991px) and (max-width: 1200px) {
            padding-right: 40px;
        }

        &-heading {
            color: $white;
            font-size: 36px;
            text-align: right;

            @media (min-width: 580px) and (max-width: 991px) {
                text-align: center;
            }

            @media screen and (max-width: 580px) {
                margin: 0 0 5px;
                text-align: left;
                line-height: 38px;
            }
        }

        &-text {
            opacity: 0.7;
            color: $white;
            font-size: 20px;
            line-height: 28px;
            text-align: right;

            @media (min-width: 580px) and (max-width: 991px) {
                text-align: center;
            }

            @media screen and (max-width: 580px) {
                text-align: left;
                margin-bottom: 30px;
            }
        }
    }

    &-content {
        &-streamer-image {
            margin-right: 15px;

            img {
                border-radius: 100%;
                border: 2px solid #FFFFFF;

                @media screen and (max-width: 580px) {
                    width: 65px;
                }
            }
        }

        &-single {
            display: flex;
            max-width: 450px;

            @media (min-width: 580px) and (max-width: 991px) {
                align-items: center;
                max-width: inherit;
            }

            &:first-child {
                margin-bottom: 30px;
            }
        }

        &-quote {
            border-left: none;
            margin: 0;
            padding: 0;
            color: $white;
            font-size: 14px;
            line-height: 21px;
        }

        &-streamer-name {
            margin-bottom: 5px;
            font-weight: 700;
        }
    }
}

</style>
